var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-row",
        { staticClass: "mt-1" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "label",
                { staticClass: "d-block mb-1 trip-inclusion-subheader" },
                [_vm._v("Included")]
              ),
              _vm._v(" "),
              _vm._l(_vm.includedItems, function (item, index) {
                return _c(
                  "v-row",
                  {
                    key: index,
                    staticClass: "trip-inclusion-item mb-2",
                    attrs: { dense: "", align: "center" },
                  },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "9" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Description",
                            "hide-details": "",
                            outlined: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.includedItems[index].description,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.includedItems[index],
                                "description",
                                $$v
                              )
                            },
                            expression: "includedItems[index].description",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "text-right",
                        attrs: { cols: "12", sm: "3" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Move up",
                              disabled: index === 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveUp("includedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("arrow_upward")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Move down",
                              disabled: index === _vm.includedItems.length - 1,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveDown("includedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("arrow_downward")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ies-coral--text",
                            attrs: { icon: "", small: "", title: "Delete" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem("includedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: { cols: "12", sm: "3", "offset-sm": "9" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ies-green",
                  attrs: { title: "Add Included Item" },
                  on: {
                    click: function ($event) {
                      return _vm.addIncludedItem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "label",
                { staticClass: "d-block mb-1 trip-inclusion-subheader" },
                [_vm._v("Not Included")]
              ),
              _vm._v(" "),
              _vm._l(_vm.notIncludedItems, function (item, index) {
                return _c(
                  "v-row",
                  {
                    key: index,
                    staticClass: "trip-inclusion-item mb-2",
                    attrs: { dense: "", align: "center" },
                  },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "9" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Description",
                            "hide-details": "",
                            outlined: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.notIncludedItems[index].description,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.notIncludedItems[index],
                                "description",
                                $$v
                              )
                            },
                            expression: "notIncludedItems[index].description",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "text-right",
                        attrs: { cols: "12", sm: "3" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Move up",
                              disabled: index === 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveUp("notIncludedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("arrow_upward")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: "Move down",
                              disabled:
                                index === _vm.notIncludedItems.length - 1,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveDown("notIncludedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("arrow_downward")])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ies-coral--text",
                            attrs: { icon: "", small: "", title: "Delete" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem("notIncludedItems", index)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: { cols: "12", sm: "3", "offset-sm": "9" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ies-green",
                  attrs: { title: "Add Not Included Item" },
                  on: {
                    click: function ($event) {
                      return _vm.addNotIncludedItem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: this.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }